module.exports = __webpack_public_path__ + "static/media/04_hero_tablet.3bcb16c2.jpg";